/** Channel = the specific ad channel within a platform (e.g. google_search, google_pmax, meta). */
export const CHANNEL_LABELS: Record<string, string> = {
  google_search: 'Google Search',
  google_pmax: 'Google PMax',
  google_display: 'Google Display',
  google_lsa: 'Google LSAs',
  meta: 'Facebook / Instagram',
  tiktok: 'TikTok',
};

export const ALL_CHANNELS: { value: string; label: string; available: boolean }[] = [
  { value: 'google_search', label: 'Google Search', available: true },
  { value: 'google_pmax', label: 'Google PMax', available: true },
  { value: 'meta', label: 'Facebook / Instagram', available: true },
  { value: 'tiktok', label: 'TikTok', available: false },
];

export const STATUS_LABEL: Record<string, string> = {
  recommended: 'Recommended',
  draft: 'Draft',
  generating: 'Generating',
  ready_for_review: 'Review',
  approved: 'Approved',
  launching: 'Launching',
  live: 'Live',
  dismissed: 'Dismissed',
};

export const DEPLOY_STATUS_COLOR: Record<string, string> = {
  draft: 'var(--gray-500)',
  ready: 'var(--primary-400)',
  approved: '#3b82f6',
  launching: '#f59e0b',
  live: '#22c55e',
  failed: '#ef4444',
};

export const DEPLOY_STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  ready: 'Ready for review',
  approved: 'Approved',
  launching: 'Launching…',
  live: 'Live',
  failed: 'Failed',
};

export function channelLabel(ch: string) {
  return CHANNEL_LABELS[ch] ?? ch;
}
